export abstract class HtmlBridge{
    abstract release();    
}
